import React from "react";
import { cn } from "@/lib/utils";

/** Official Mediability wordmark (SVG from mediability.com). variant: "dark" (for light UI) | "white" (for dark panels). */
export const MediabilityLogo = ({ variant = "dark", className, testId }) => (
  <img src={`/brand/mediability-logo-${variant}-red.svg`} alt="Mediability" draggable={false} className={cn("h-6 w-auto select-none", className)} data-testid={testId || "mediability-logo"} />
);

/** Official Mediability "M" mark. */
export const MediabilityMark = ({ className, testId }) => (
  <img src="/brand/mediability-M-logo.svg" alt="Mediability" draggable={false} className={cn("h-7 w-7 select-none", className)} data-testid={testId || "mediability-mark"} />
);
